import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Toast } from "react-bootstrap";
import Langs, { Localize } from "../../app/lang/langs";
import styles from "./Reports.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from 'primereact/api';
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { getTagClass } from "../../app/utils/helpers";
import { FloatLabel } from "primereact/floatlabel";

export function PublicationsView() {

    const dispatch = useDispatch()

    const publications = useSelector((state) => state.reports.publications)
    const isMobile = useSelector((state) => state.settings.isMobile)

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })

    const toast = useRef(null)
    const dt = useRef(null)
    const mounted = useRef(null)

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
        }
    })

    const onGlobalFilterChange = (e) => {
        const value = e.target.value
        let _filters = { ...filters }

        _filters['global'].value = value

        setFilters(_filters)
        setGlobalFilterValue(value)
    }

    const actionBodyTemplate = (rowData) => {

    }

    const statusBodyTemplate = (rowData) => {
        return <Tag
            value={<Langs str={rowData.status} />}
            severity={getTagClass(rowData.status)}>
        </Tag>
    }

    const header = isMobile == 3 ? null : (
        <Row>
            <Col md={6}>
                <span className="p-input-icon-left">
                        <InputText
                            id="search-report"
                            type="search"
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Search..."
                        />
                </span>
            </Col>
            <Col md={9}></Col>
        </Row>
    )

    let tabelHeight = "calc(100vh - 315px)"
    switch (isMobile) {
        case 2:
            tabelHeight = "calc(100vh - 420px)"
            break;
        case 3:
            tabelHeight = "calc(100vh - 200px)"
            break;
        default:
            break;
    }
    return <div>
        <Toast ref={toast} />
        <div className={styles.card}>
            <DataTable ref={dt} value={publications}
                paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50, 100]} scrollable
                scrollHeight={tabelHeight}
                paginatorTemplate={"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"}
                currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                header={header}
                filters={filters}>
                {/* <Column selectionMode="multiple" exportable={false}></Column> */}
                <Column field="name" header={<Langs str="Client" />} sortable style={{ minWidth: '11rem' }}></Column>
                <Column field="createdAt" header={<Langs str="CREATED_AT" />} sortable style={{ minWidth: '12rem' }}></Column>
                <Column field="createdBy" header={<Langs str="CREATED_BY" />} sortable style={{ minWidth: '12rem' }}></Column>
                <Column field="status" header={<Langs str="status" />} body={statusBodyTemplate} sortable style={{ minWidth: '8rem' }}></Column>
                {isMobile == 1 && (
                    <Column
                        body={actionBodyTemplate}
                        exportable={false}
                        style={{ minWidth: '6rem', textAlign: "right" }}
                        frozen
                        alignFrozen="right"
                    />
                )}
            </DataTable>
        </div>
    </div>
}
